<template>
  <PageContentLayoutOnly :aria-label="$t('lotFileDocument.title')" role="region">
    <div>
      <b-button
        type="is-primary"
        class="is-rounded"
        @click="addLotFileDocument()"
        emergency-contact-addition-button
        :style="{ marginBottom: '20px' }"
        >Add Document</b-button
      >
    </div>
    <ModernTable :columns="columns" :rows="rows" :filters="filters" headerColor="#FFF" condensed />
    <Modal :toggle.sync="showModal" :styles="{ modal: { height: '70vh' } }">
      <div class="is-size-4" v-if="formData">
        {{ action === 'Update' ? 'Update Lot File Document' : 'Add Lot File Document' }}
      </div>
      <ValidationObserver ref="formGroup" v-slot="{ handleSubmit }">
        <transition name="fade" mode="out-in" appear>
          <form @submit.prevent="handleSubmit(submitLotFile)">
            <fieldset>
              <div v-if="action !== 'Add'" class="column is-12">
                <valid-input
                  disabled="true"
                  name="lotFileDocumentID"
                  label="Lot File Document"
                  type="text"
                  placeholder="Lot File Document"
                  spellcheck="true"
                  aria-label="Lot File Document"
                  vid="lotFileDocumentID"
                  v-model="formData.lotFileDocumentID"
                />
              </div>
              <div class="column is-12">
                <valid-input
                  style="width:50px !important;"
                  disabled="true"
                  name="owner"
                  label="Owner"
                  type="text"
                  vid="owner"
                  placeholder="Owner"
                  spellcheck="true"
                  aria-label="Owner"
                  rules="required"
                  class="is-small"
                  v-model="formData.owner"
                />
              </div>
              <div class="column is-12">
                <valid-input
                  style="width:50px !important;"
                  disabled="true"
                  name="Address"
                  label="Address"
                  type="text"
                  vid="address"
                  placeholder="Address"
                  spellcheck="true"
                  aria-label="Address"
                  class="is-small"
                  v-model="formData.address"
                />
              </div>
              <div class="column is-12">
                <valid-input
                  style="width:50px !important;"
                  name="Description"
                  label="Description"
                  type="text"
                  required="true"
                  vid="description"
                  placeholder="Description"
                  spellcheck="true"
                  aria-label="Description"
                  class="is-small"
                  v-model="formData.description"
                />
              </div>
              <div class="column is-12">
                <valid-select
                  label="Category"
                  placeholder="Categories"
                  vid="lotFileCategoryID"
                  required="true"
                  rules="required"
                  v-model="formData.lotFileCategoryID"
                >
                  <option
                    v-for="option in categoryList"
                    :value="option.value"
                    :key="option.value"
                    >{{ option.label }}</option
                  >
                </valid-select>
              </div>
              <div>
                <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                  <div class="field">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>

              <div v-if="action !== 'Add'">
                <div v-if="selectedDocument.documentURL" class="force-center subtitle pb-5">
                  Preview File
                </div>
                <div id="viewpdf" v-if="selectedDocument.documentURL" class="has-text-centered">
                  <div>
                    <div>
                      <doc-viewer3 :path="selectedDocument.documentURL" />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </transition>
      </ValidationObserver>

      <div class="box is-8">
        <section>
          <div>
            <!-- Show the Upload Form -->
            <b-field class="file">
              <b-upload v-model="file" drag-drop accept="application/pdf" class="rectangle">
                <section class="section">
                  <div class="">
                    <div>
                      <img
                        class="Fill-1-Copy-11"
                        src="@/assets/images/fill-1-copy-11.svg"
                        alt="Upload"
                      />
                    </div>
                    <div v-if="file">
                      {{ file.name }}
                    </div>
                    <div v-else>
                      <div class="Drag-Drop-your-fil">
                        <div class="text-style-1">Drag & Drop</div>
                        <div>Please upload PDF files</div>
                      </div>
                    </div>
                  </div>
                </section>
              </b-upload>
            </b-field>
          </div>
          <div class="pt-5">
            <span
              class="pr-5"
              v-if="
                attachment == false &&
                  !selectedDocument.documentURL &&
                  this.file !== undefined &&
                  this.file
              "
              ><b-button type="button is-primary is-rounded" @click="submitFile"
                >Save</b-button
              ></span
            >
            <span
              class="pr-5"
              v-else-if="
                selectedDocument.documentURL !== undefined &&
                  selectedDocument.documentURL &&
                  this.action === 'Update' &&
                  this.file !== undefined &&
                  this.file
              "
              ><b-button type="button is-primary is-rounded" :disabled="!file" @click="replaceFile"
                >Save</b-button
              ></span
            >
            <span v-else class="pr-5">
              <button type="button" @click="submitLotFile" class="button is-primary is-rounded">
                Save
              </button></span
            >
          </div>
        </section>
      </div>
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import _get from 'lodash/get'
import kms from '@/services/kms'
import { mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

// components
import ValidInput from '@/components/inputs/ValidInput'
import ValidSelect from '@/components/inputs/ValidSelect'
import Modal from '@/components/Modal'
import ModernTable from '@/components/tables/Modern/Table'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { data } from './keys/data'
import { methods } from './keys/methods'
import { watch } from './keys/watch'
import { dragscroll } from 'vue-dragscroll'
import DocViewer3 from '@/components/DocViewer3'

export default {
  components: {
    Modal,
    ModernTable,
    PageContentLayoutOnly,
    ValidationObserver,
    ValidationProvider,
    ValidInput,
    ValidSelect,
    DocViewer3
  },

  directives: { dragscroll },

  props: {
    kms: {
      type: Object,
      default: () => {
        return kms
      }
    }
  },

  data,

  async created() {
    await this.getRefreshedLotFileDocuments().then(() => {
      this.getCategories()
    })
  },

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  async mounted() {
    console.debug('mounted document list...')
    this.ownerID = _get(this, '$store.state.hoa.unit.primaryOwner.ownerID', null)
    this.unitID = _get(this, '$store.state.hoa.unit.unitID', null)
    this.addressID = _get(this, '$store.state.hoa.unit.address.addressID', null)
    this.defaultOwnerName = _get(this, '$store.state.hoa.unit.primaryOwner.name', '')
    this.defaultAddress = _get(this, '$store.state.hoa.unit.address', null)

    await this.getRefreshedLotFileDocuments().then(() => {
      this.getCategories()
    })
    if (this.isDebug == true) console.debug('mounted ownerID=' + this.ownerID)
  },

  watch,
  methods,

  i18n: {
    messages: {
      en: { lotFileDocument: { title: 'Documents' } }
    }
  }
}
</script>
